export default __webpack_public_path__ + "static/media/48-icon-map.5326fbdd.svg";